module.exports = __webpack_public_path__ + "static/media/Complimentary Sunday.32b92fab.png";